import { useReducer } from 'react'

import { DataContext, DataDispatchContext } from './constants'
import DataReducer from './dataReducer'
import initialDataState from './initialState'

const DataProvider = ({ children }: { children: React.ReactNode }) => {
    const [data, dispatch] = useReducer(DataReducer, initialDataState)

    return (
        <DataContext.Provider value={data}>
            <DataDispatchContext.Provider value={dispatch}>{children}</DataDispatchContext.Provider>
        </DataContext.Provider>
    )
}

export default DataProvider
